// extracted by mini-css-extract-plugin
export default {"noResultsImage":"styles_noResultsImage__ZSvab","orderTime":"styles_orderTime__Fvcsq"};